import * as d3 from 'd3'
export default {
  methods: {

    save_Diagram() {

      let fields = [
        {code: 'DIAGRAM_NAME',  update: 'Y'},
        {code: 'DIAGRAM_DESC',  update: 'Y'},
        {code: 'VERIFY_MODAL',  update: 'Y'},
        {code: 'DEV_DB',        update: ''},
        {code: 'DEV_SCHEMA',    update: ''},
        {code: 'DEV_PROCEDURE', update: '2'},
        {code: 'SVS_DB',        update: ''},
        {code: 'SVS_SCHEMA',    update: ''},
        {code: 'SVS_PROCEDURE', update: '2'},
        {code: 'CUTOFF_DB',     update: ''},
        {code: 'CUTOFF_SCHEMA', update: ''},
        {code: 'CUTOFF_TBL',    update: ''},
        {code: 'CUTOFF_CODE',   update: ''},
        {code: 'CUTOFF_DATE',   update: 'Y'},
      ]

      fields.forEach(d=> {
        if(d3.select(`#DIA_${d.code}`)) {

          this.diagram[d.code] = d3.select(`#DIA_${d.code}`).text()
        } else this.diagram[d.code] = ''
      })

      fields.filter(f=> f.update).forEach(d=> {
        if(d.update == 'Y') d3.select(`#${d.code}`).text(this.diagram[d.code])
        if(d.update == '2') d3.select(`#${d.code}`).text(`${this.diagram[`${d.code.split('_')[0]}_SCHEMA`]}.${this.diagram[d.code]}`)
      })

      if(this.diagram.CUTOFF_DATE) {
        let updated = new Date(this.diagram.CUTOFF_DATE)
        d3.select(`#CUTOFF_MONTH`).text(updated.toLocaleString('en-US', { month: 'long' }))
        d3.select(`#CUTOFF_DAY`)  .text(updated.getDate())
      }

      this.diagram_Coloring() // -----> Below
      this.close_Window()
    },

    
    diagram_Coloring(){
      let dia = this.diagram
      if(dia.VERIFY_MODAL) d3.select(`#VERIFY_MODAL`).attr('fill', '#44A9DF')
      if(dia.DEV_DB && dia.DEV_SCHEMA && dia.DEV_PROCEDURE) d3.select(`#DEV_PROCEDURE`).attr('fill', '#44A9DF')
      if(dia.SVS_DB && dia.SVS_SCHEMA && dia.SVS_PROCEDURE) d3.select(`#SVS_PROCEDURE`).attr('fill', '#44A9DF')
      if(dia.CUTOFF_DB && dia.CUTOFF_SCHEMA && dia.CUTOFF_TBL && dia.CUTOFF_CODE && dia.CUTOFF_DATE) d3.select(`#CUTOFF_DATE`).attr('fill', '#44A9DF')
    },


    exec_Procedure(selection, str) {
      let this_ = this
      selection
      .attr('cursor', 'default')
      .on('mouseover', function() {
        if(!this_.check_Procedure(selection, str)) return
        d3.select(this).transition().duration(75).style('opacity', .4)
      })
      .on('mouseout', function() {
        if(!this_.check_Procedure(selection, str)) return
        d3.select(this).transition().duration(250).style('opacity', 1)
      })
      .on('click', async () => {
        if (!this_.check_Procedure(selection, str)) return
        this.cbDataReady = new Promise(resolve => {
          this.resolveCbData = resolve
        })

        const reqId = this_.makeProcId ? this_.makeProcId() : `${this.localId}_EXCEL_EXPORT_PROC`

        const request = {
          requestId: reqId,
          type: 'PROCEDURE',
          server: 'golden',
          name: '[G08_SystemCompletion].[SC].[Import_System_Completion]',
          whereCondition: '',
          dataDate: '20260329',
          files: [
            {type : 'EXCEL', name: 'test.xlsx', path : 'f:\test'},
            {type : 'EXCEL', name: 'test1.xlsx', path : 'f:\test'},
            {type : 'EXCEL', name: 'test2.xlsx', path : 'f:\test'},
          ],
          data: [
            { IDX: 1, SN: 1, PHASE: 'zzzzz',     DIAGRAM: 'P6 SCHEDULE',       DESCR: 'Project Schedule Uploading & Updating', MANAGER: 'Jinkee',   PREQUENCY: 'Weekly',  UPDATED: '2026-01-12', VERIFY: 'MD_001', DEV_DB: 'K03_Planning',     DEV_SCM: 'SCH',    DEV_SP: 'DEV_P6_Data',   SVS_DB: 'K03_Planning',     SVS_SCM: 'SCH',    SVS_SP: 'Service_P6_Data',   CTO_DB: 'K01_Project',      CTO_SCM: 'CUTOFF', CTO_TBL: 'Schedule', CTO_CODE: 'P6',  CTO_DATE: '2026-01-11', },
            { IDX: 2, SN: 2, PHASE: 'PLANNING',     DIAGRAM: 'EPC SCURVE',        DESCR: 'EPC Progress Uploading & Updating',     MANAGER: 'JeYoung',  PREQUENCY: 'Monthly', UPDATED: '2026-01-08', VERIFY: 'MD_002', DEV_DB: 'K03_Planning',     DEV_SCM: 'SCH',    DEV_SP: 'DEV_P6_Scurve', SVS_DB: 'K03_Planning',     SVS_SCM: 'SCH',    SVS_SP: 'Service_P6_Scurve', CTO_DB: 'K01_Project',      CTO_SCM: 'CUTOFF', CTO_TBL: 'Schedule', CTO_CODE: 'EPC', CTO_DATE: '2025-12-28', },
            { IDX: 3, SN: 3, PHASE: 'QUALITY',      DIAGRAM: 'Quality Conrtrol',  DESCR: 'Project Schedule Uploading & Updating', MANAGER: 'Taegu',    PREQUENCY: 'Weekly',  UPDATED: '2026-01-12', VERIFY: 'MD_001', DEV_DB: 'K06_Quality',      DEV_SCM: 'SCH',    DEV_SP: 'DEV_P6_Data',   SVS_DB: 'K06_Quality',      SVS_SCM: 'SCH',    SVS_SP: 'Service_P6_Data',   CTO_DB: 'K06_Quality',      CTO_SCM: 'CUTOFF', CTO_TBL: 'Schedule', CTO_CODE: 'P6',  CTO_DATE: '2026-01-11', },
            { IDX: 4, SN: 4, PHASE: 'CONSTRUCTION', DIAGRAM: 'MASTER BLOCK LIST', DESCR: 'EPC Progress Uploading & Updating',     MANAGER: 'JunHyeng', PREQUENCY: 'Weekly',  UPDATED: '2026-01-08', VERIFY: 'MD_002', DEV_DB: 'K07_Construction', DEV_SCM: 'Master', DEV_SP: 'DEV_P6_Scurve', SVS_DB: 'K07_Construction', SVS_SCM: 'Master', SVS_SP: 'Service_P6_Scurve', CTO_DB: 'K07_Construction', CTO_SCM: 'CUTOFF', CTO_TBL: 'Schedule', CTO_CODE: 'EPC', CTO_DATE: '2025-12-28', },
          ],
        }
        console.log('svg3 click event exec_Procedure - request', request)
        if (typeof this_.$emit === 'function') {
          this_.$emit('request-procedure', request)
        }

        console.log('before await this.cbDataReady')
        await this.cbDataReady
        console.log('after await this.cbDataReady')
        console.log('this.cbData: ', this.cbData)

      })
    },

    check_Procedure(selection, str) {
      let dia = this.diagram
      switch(str) {
        case 'VERIFY':
          if(this.diagram.VERIFY_MODAL) {
            selection.attr('cursor', 'pointer')
            return true
          }
        break

        case 'DEV':
          if(dia.DEV_DB && dia.DEV_SCHEMA && dia.DEV_PROCEDURE) {
            selection.attr('cursor', 'pointer')
            return true
          }
        break

        case 'SERVICE':
          if(dia.SVS_DB && dia.SVS_SCHEMA && dia.SVS_PROCEDURE) {
            selection.attr('cursor', 'pointer')
            return true
          }
        break

        case 'CUTOFF':
          if(dia.CUTOFF_DB && dia.CUTOFF_SCHEMA && dia.CUTOFF_TBL && dia.CUTOFF_CODE && dia.CUTOFF_DATE) {
            selection.attr('cursor', 'pointer')
            return true
          }
        break
      }
    },

    

  }
}